import { render, staticRenderFns } from "./ProjectsByCategory.vue?vue&type=template&id=0fb42f8d&scoped=true&"
import script from "./ProjectsByCategory.vue?vue&type=script&lang=js&"
export * from "./ProjectsByCategory.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsByCategory.vue?vue&type=style&index=0&id=0fb42f8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb42f8d",
  null
  
)

export default component.exports